// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProfilePage_container__HAlWm {
  text-align: center;
  max-width: 500px;
  padding: 24px 16px;
  max-width: 500px;
  margin: 0 auto;
  color: white;
  min-height: 100vh;
}

.ProfilePage_title__qrAwv {
  font-size: 27px;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 60px;
}

.ProfilePage_birthTimeWrapper__m2zKR {
  margin-bottom: 5px;
}

.ProfilePage_form__Iw2C- {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.ProfilePage_supportBlock__zxgLX {
  text-align: center;
}

.ProfilePage_supportBlock__zxgLX p {
  margin-bottom: 25px;
  font-size: 14px;
  color: #cccccc;
  line-height: 1.5;
}

.ProfilePage_suggestionList__UWREf {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 9999;
  background: linear-gradient(135deg, #5b2a85, #3b0a60);
  max-height: 200px;
  overflow-y: auto;
  list-style: none;
  padding: 10px 0;
  border-radius: 16px;
  box-shadow: 0 0 12px rgba(143, 100, 200, 0.35), 0 4px 18px rgba(100, 50, 170, 0.3),
    inset 0 0 6px rgba(200, 150, 255, 0.08);
  transition: all 0.2s ease;
  color: white;
}

.ProfilePage_suggestionItem__AI4Du {
  padding: 8px 12px;
  cursor: pointer;
}

.ProfilePage_suggestionItem__AI4Du:hover {
  background: rgba(255, 255, 255, 0.04);
}

.ProfilePage_radioGroup__tQri5 {
  display: flex;
  gap: 1rem;
  margin-bottom: 25px;
}

.ProfilePage_radioGroup__tQri5 label {
  display: block;
  padding: 8px 12px;
  background-color: rgba(255, 255, 255, 0.06);
  border-radius: 12px;
  margin-bottom: 8px;
  cursor: pointer;
  transition: background 0.2s;
}

.ProfilePage_radioGroup__tQri5 input[type="radio"] {
  accent-color: #a66cff;
  margin-right: 10px;
}

.ProfilePage_radioGroup__tQri5 label:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.ProfilePage_errorText__Kk95G {
  color: #d48fff;
  font-size: 12px;
  line-height: 1.5;
  margin-bottom: 5px;
  padding-left: 4px;
  min-height: 18px;
  text-align: left;
}

.ProfilePage_invalid__WBEbk {
  border-color: #d48fff;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ProfilePage/ProfilePage.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,qDAAqD;EACrD,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB;2CACyC;EACzC,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":[".container {\n  text-align: center;\n  max-width: 500px;\n  padding: 24px 16px;\n  max-width: 500px;\n  margin: 0 auto;\n  color: white;\n  min-height: 100vh;\n}\n\n.title {\n  font-size: 27px;\n  font-weight: 700;\n  color: #ffffff;\n  margin-bottom: 60px;\n}\n\n.birthTimeWrapper {\n  margin-bottom: 5px;\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.supportBlock {\n  text-align: center;\n}\n\n.supportBlock p {\n  margin-bottom: 25px;\n  font-size: 14px;\n  color: #cccccc;\n  line-height: 1.5;\n}\n\n.suggestionList {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  z-index: 9999;\n  background: linear-gradient(135deg, #5b2a85, #3b0a60);\n  max-height: 200px;\n  overflow-y: auto;\n  list-style: none;\n  padding: 10px 0;\n  border-radius: 16px;\n  box-shadow: 0 0 12px rgba(143, 100, 200, 0.35), 0 4px 18px rgba(100, 50, 170, 0.3),\n    inset 0 0 6px rgba(200, 150, 255, 0.08);\n  transition: all 0.2s ease;\n  color: white;\n}\n\n.suggestionItem {\n  padding: 8px 12px;\n  cursor: pointer;\n}\n\n.suggestionItem:hover {\n  background: rgba(255, 255, 255, 0.04);\n}\n\n.radioGroup {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 25px;\n}\n\n.radioGroup label {\n  display: block;\n  padding: 8px 12px;\n  background-color: rgba(255, 255, 255, 0.06);\n  border-radius: 12px;\n  margin-bottom: 8px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.radioGroup input[type=\"radio\"] {\n  accent-color: #a66cff;\n  margin-right: 10px;\n}\n\n.radioGroup label:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.errorText {\n  color: #d48fff;\n  font-size: 12px;\n  line-height: 1.5;\n  margin-bottom: 5px;\n  padding-left: 4px;\n  min-height: 18px;\n  text-align: left;\n}\n\n.invalid {\n  border-color: #d48fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ProfilePage_container__HAlWm`,
	"title": `ProfilePage_title__qrAwv`,
	"birthTimeWrapper": `ProfilePage_birthTimeWrapper__m2zKR`,
	"form": `ProfilePage_form__Iw2C-`,
	"supportBlock": `ProfilePage_supportBlock__zxgLX`,
	"suggestionList": `ProfilePage_suggestionList__UWREf`,
	"suggestionItem": `ProfilePage_suggestionItem__AI4Du`,
	"radioGroup": `ProfilePage_radioGroup__tQri5`,
	"errorText": `ProfilePage_errorText__Kk95G`,
	"invalid": `ProfilePage_invalid__WBEbk`
};
export default ___CSS_LOADER_EXPORT___;
